
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class BrandAmbassadorPayoutDialog extends Serenity.EntityDialog<BrandAmbassadorPaymentsRow, any> {
        protected getFormKey() { return BrandAmbassadorPayoutForm.formKey; }
        protected getIdProperty() { return BrandAmbassadorPaymentsRow.idProperty; }
        protected getLocalTextPrefix() { return BrandAmbassadorPaymentsRow.localTextPrefix; }
        protected getService() { return BrandAmbassadorPaymentsService.baseUrl; }

        protected form = new BrandAmbassadorPayoutForm(this.idPrefix);

        public rowids: string;
        private checkgrid: OrderFranchiseeShareCalculationGrid;
        constructor(gridToRefresh, FormMode, selectedids) {

            super();

            this.form = new BrandAmbassadorPayoutForm(this.idPrefix);
            //debugger;
            this.rowids = selectedids;

            this.form.BrandAmbassadorId.change(e => {
                debugger;
                var vfranchiseeId = this.form.BrandAmbassadorId.value;

                if (Q.isEmptyOrNull(vfranchiseeId)) {
                    //this.setShippingProviderDetails({});
                }
                else {
                    try {
                        debugger;
                        BrandAmbassadorPaymentsService.GetBrandAmbassadorTotalShare({
                            rowIds: this.rowids,
                            //      
                        }, response => {
                            this.form.PaidAmount.value = response.PaidAmount;
                            
                        });
                    } catch (e) {

                    }
                }
            });
        }

        loadEntity(entity: FranchiseePaymentsRow) {
            //debugger;
            super.loadEntity(entity);
            //debugger;
            this.form.RowIds.value = this.rowids;
            Serenity.EditorUtils.setReadOnly(this.form.PaidAmount, true);           
        }

        onSaveSuccess(response) {
            super.onSaveSuccess(response);
            //debugger;
            if (this.form.RowIds.value != "") {
                Q.notifySuccess("Added sucessfully");
                //this.Questionsgrid.rowSelection.resetCheckedAndRefresh();
                //this.Questionsgrid.refresh();
            }

        }
    }
}